import { BaseStore } from 'fluxible/addons';

export default class BookCalculatorFieldOptionStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);

        this.options = {};
    }

    loadOptions(options) {
        this.options = options;
        this.emitChange();
    }

    getOptions() {
        return this.options;
    }
}

BookCalculatorFieldOptionStore.storeName = 'BookCalculatorFieldOptionStore';

BookCalculatorFieldOptionStore.handlers = {
    LOAD_FIELD_OPTIONS: 'loadOptions',
};
